import { RouteConfig } from "vue-router";
import store from '@/store';
import cookie from '@/api/cookie';
import REQ_URL from '@/consts/req-url';
import { $fetch } from '@/api/fetch';

class Auth {
	async check() {
		return !!( store.getters.isAuth || await this.auth() )
	}
	async auth() {
		try {
			let ssid = cookie.getCookie('PHPSESSID') ? cookie.getCookie('PHPSESSID') + '' : '';
			if (!ssid) return false
			
			let data = await $fetch(REQ_URL.GET_PROFILE, {
				headers: {
					'PHPSESSID': ssid
				}
			})

			if (data.body) store.dispatch('setProfile', data.body)
			else throw new Error('Response body are empty');
			return true
		} catch (error) {
			console.error(error)
			return false
		}
	}
}

export default new Auth()

